export default __webpack_public_path__ + "static/media/top-b-10-med.bbc2eabf.jpg";